import React from 'react';
import PageBanner from './PageBanner';
import { Col, Container, Row } from 'react-bootstrap';
import CostCalculator from './CostCalculator';
import helpDeskIcon from '../assets/images/help-desk-icon.png';

const Contact = () => {
    return (
        <>
            <div className='contact-us'>
                <PageBanner msgLine2={"Contact Us"} />
                <div className='contact-details'>
                    <Container>
                        <Row>
                            <Col md={7}>
                                <div className='contact'>
                                    <div className='img'>
                                        <img src={helpDeskIcon} />
                                    </div>
                                    <div className='xyz'>
                                        <div className='address'>
                                            <h6>Phone</h6>
                                            <p>+91 xxxxx xxxxx</p>
                                        </div>
                                        <div className='address'>
                                            <h6>Email</h6>
                                            <p>contact@zeeepy.com</p>
                                        </div>
                                        <div className='address'>
                                            <h6>Address</h6>
                                            <p><b>Zeeepy</b><br/>
                                                7 Temasek Boulevard #12-07 Suntec Tower One Singapore 038987</p>
                                        </div>
                                    </div>

                                </div>
                            </Col>
                            <Col md={5}>
                                <div>
                                    <CostCalculator />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default Contact